import type { FC } from 'react';
import { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { SubscriptionBanner, SubscriptionPaymentProvider } from '@/features/subscription';
import { BottomNavigation } from './BottomNavigation';
import styles from './Layout.module.css';

export const Layout: FC = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <SubscriptionPaymentProvider>
      <main id="main-content" className={styles.content}>
        <SubscriptionBanner />
        <Outlet />
      </main>
      <BottomNavigation />
    </SubscriptionPaymentProvider>
  );
};
